import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Active entity context — kept in localStorage under `ukn_active_entity`
 * so it survives reloads and page nav. Pages read this in useEffect or
 * directly inside their query hooks.
 */
type EntityState = {
  entityId: string | null;
  setEntity: (id: string | null) => void;
};

export const useEntityStore = create<EntityState>()(
  persist(
    (set) => ({
      entityId: null,
      setEntity: (id) => set({ entityId: id }),
    }),
    { name: 'ukn_active_entity' },
  ),
);
